import React from 'react';
import PropTypes from 'prop-types';
import { PanelGroup } from 'react-bootstrap';

import PanelComponent from '../../../../core/PanelComponent/PanelComponent';
import NamespaceGridComponent from '../NamespaceGridComponent';
import GridContainer from '../../../../../containers/GridContainer';
import CodeComponent from '../../../../core/CodeComponent/CodeComponent';
import { DATA_NAMES } from '../DataTypesConstants';

import './data.scss';

const _ = require('lodash');

class DataComponent extends React.Component {
    ABBREVIATIONS = ['LF', 'GPS']

    DESCRIPTION_GRID_PROP = {
        id: 'description',
        title: 'Description',
        className: 'description',
    }

    XML_GRID_PROPS = [
        {
            title: 'Name (type)',
            className: 'name',
            getter: ({ isArray, name, type }) => <div>
                <span>
                    {name}&nbsp;
                    ({isArray
                        ? <a onClick={() => this.handleSelect(DATA_NAMES.types, this.getTypePanelKey(type))}>{type}</a>
                        : type})
                </span>
            </div>,
        },
        {
            title: 'Min/Max Occurs',
            className: 'occurs',
            getter: ({ minOccurs, maxOccurs }) => <div>
                <span>{`${minOccurs}/${maxOccurs}`}</span>
            </div>,
        },
        this.DESCRIPTION_GRID_PROP,
    ]

    JSON_GRID_PROPS = [
        {
            id: 'name',
            title: 'Property',
            className: 'property',
        },
        {
            title: 'Type',
            className: 'type',
            getter: ({ isArray, name, type }) => <div>
                <span>
                    {isArray ? 'array of ' : ''}{name}&nbsp;
                    ({isArray
                        ? <a onClick={() => this.handleSelect(DATA_NAMES.types, this.getTypePanelKey(type))}>{type}</a>
                        : type})
                </span>
            </div>,
        },
        this.DESCRIPTION_GRID_PROP,
    ]

    getCamelCaseText = (text) => {
        text = _.camelCase(text);

        const existingAbbreviations = text.toUpperCase().match(
            new RegExp(`(${this.ABBREVIATIONS.join('|')})`, 'g')
        );

        if (existingAbbreviations) {
            existingAbbreviations.forEach((abbreviation) => {
                text = text.replace(new RegExp(abbreviation, 'ig'), abbreviation);
            });
        }

        return text;
    }

    getTypePanelKey = (type) => parseInt(document.getElementById(`${type}-panel`).children[0].id.split('-').pop(), 10);

    scrollTo = (dataName, activeKey, panelName) => {
        if (typeof activeKey === 'number') {
            const activeElementTop = document.querySelector(
                `#${dataName}-accordion #${panelName}-panel #${dataName}-accordion-heading-${activeKey}`
            ).offsetTop;
            const headerElementHeight = document.getElementById('header').offsetHeight;
            const navBarElementHeight = document.getElementsByClassName('nav nav-tabs')[0].offsetHeight;

            window.scrollTo({
                top: activeElementTop - headerElementHeight - navBarElementHeight,
                behavior: 'smooth',
            });
        }
    }

    handleSelect = (dataName, activeKey, title) => {
        const { activeKeys, setActiveKey, namespaceName } = this.props;

        if (activeKeys[dataName] === activeKey) {
            this.scrollTo(dataName, activeKey, title);
        } else {
            setActiveKey(namespaceName, dataName, activeKey);
        }
    }

    generateTypeGridItems = (properties) => {
        return Object.keys(properties).map((name) => {
            const property = properties[name];
            const { minOccurs, maxOccurs, description = '', ref } = property;
            let { type } = property;
            let isArray = type === 'array' && ref;

            if (ref) {
                type = ref;
            }

            return {
                name,
                type: this.getCamelCaseText(type),
                minOccurs,
                maxOccurs,
                description,
                isArray,
            };
        });
    }

    getSection = (key, type, isElements, items, code) => <div className={type}>
        <h4>{isElements ? 'Example ' : ' '}{type}</h4>
        {!isElements && <GridContainer
            className="data-grid"
            name={`${key}-${type}-grid`}
            gridProps={this[`${type.toUpperCase()}_GRID_PROPS`]}
            items={items}
        />}
        {isElements && <CodeComponent code={code} />}
    </div>

    render() {
        const { namespace, namespaceName, dataNames, activeKeys } = this.props;

        return dataNames.map((dataName, index) => {
            const activeKey = activeKeys[dataName];
            const data = namespace[dataName];
            const isElements = dataName === DATA_NAMES.elements;

            return data && <div className="data" key={index}>
                <h4>Data {_.capitalize(dataName)}</h4>
                <PanelGroup
                    accordion
                    id={`${dataName}-accordion`}
                    onSelect={(activeKey) => this.handleSelect(dataName, activeKey)}
                    activeKey={activeKey}
                >
                    {Object.keys(data).map((key, index) => {
                        const value = data[key];
                        const title = this.getCamelCaseText(key);
                        let gridItems = [];
                        let typeElementIndex = index;

                        if (!isElements) {
                            gridItems = this.generateTypeGridItems(value.properties);
                        } else {
                            typeElementIndex = Object.keys(namespace[DATA_NAMES.types]).indexOf(key);
                        }

                        return <PanelComponent
                            key={index}
                            eventKey={index}
                            activeKey={activeKey}
                            title={title}
                            eventProps={{
                                onEntered: () => this.scrollTo(dataName, activeKey, title),
                            }}
                        >
                            <NamespaceGridComponent
                                namespace={namespace}
                                name={namespaceName}
                                elementName={title}
                                dataName={dataName}
                                onTypeClick={() => this.handleSelect(DATA_NAMES.types, typeElementIndex, title)}
                            />
                            {this.getSection(title, 'xml', isElements, gridItems, value.xml)}
                            {this.getSection(title, 'json', isElements, gridItems, value.json)}
                        </PanelComponent>;
                    })}
                </PanelGroup>
            </div>
        });
    }
}

DataComponent.propTypes = {
    namespace: PropTypes.object.isRequired,
    namespaceName: PropTypes.string.isRequired,
    dataNames: PropTypes.array.isRequired,
    activeKeys: PropTypes.object.isRequired,
    setActiveKey: PropTypes.func.isRequired,
};

export default DataComponent;



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/DataTypes/Data/DataComponent.js